<div class="footer">
  <div class="pull-right">
    {{currentDate | date: 'EEEE d/M/yy'}}
    <strong>{{currentDate | date:'shortTime'}}</strong>
  </div>
  <div>
    <strong>{{i18n.translate('general.labels.copyright')}}</strong> {{appService.productName}}&copy; {{appService.releasedYear}}-{{currentYear}}
  </div>
</div>
